import InnovativeFinancialSection from './InnovativeFinancialSection';

export default InnovativeFinancialSection;
